import React, { useContext } from "react";
import { UserContext } from "../configs/UserContext";


function Header({pageName, headerText}) {

    const { user } = useContext(UserContext);
   

    return (
        <div className='container-lg pt-3'>

            <div className='mt-2'>
                <h1 className="fs-2">{pageName}</h1>
                <p className={`${user === 'admin' ? 'd-none' : ''} fs-6 fw-normal text-justify lh-p`}>{headerText}</p>
            </div>

        </div>
    );
};

export default Header;